/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_PausedInputs */

const en_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

const de_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausiert`)
};

const fr_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En pause`)
};

const es_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausado`)
};

const it_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sospeso`)
};

const nl_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gepauzeerd`)
};

const pl_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstrzymano`)
};

const fi_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskeytetty`)
};

const da_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På pause`)
};

const sv_jobs_paused = /** @type {(inputs: Jobs_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausad`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Jobs_PausedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_paused = /** @type {((inputs?: Jobs_PausedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_PausedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_paused(inputs)
	if (locale === "fr") return fr_jobs_paused(inputs)
	if (locale === "es") return es_jobs_paused(inputs)
	if (locale === "it") return it_jobs_paused(inputs)
	if (locale === "nl") return nl_jobs_paused(inputs)
	if (locale === "pl") return pl_jobs_paused(inputs)
	if (locale === "fi") return fi_jobs_paused(inputs)
	if (locale === "da") return da_jobs_paused(inputs)
	if (locale === "sv") return sv_jobs_paused(inputs)
	return en_jobs_paused(inputs)
});